import { Component, OnInit } from '@angular/core';
import { BannerService } from '../../services/banner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NewsService } from 'src/app/services/news.service';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment';
import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface
} from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss']
})
export class NewsDetailsComponent implements OnInit {
  public comingSoonMsg= environment.comingSoonMsg;
  items: MenuItem[];
  public loading: boolean;
  public newsContent;
  public newsTitle;
  public newsContentData;
  public errorMessage: string;
  public bannerList: any[];
  public totalRecords = 0;
  public bannerImageList: any[] = [];
  public blogs:any[];
  public disabled: boolean = false;
  public newsImage: any[];
  tplNews: any[] = [];
  public id;
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  public blogs_config: SwiperConfigInterface = {
    direction: "vertical",
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',

    speed: 400,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    slidesPerView: 'auto',
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      480: {
        direction: "horizontal",
        slidesPerView: 3,
        spaceBetween: 10
      },
      640: {
        direction: "horizontal",
        slidesPerView: 3,
        spaceBetween: 15
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      2500: {
        slidesPerView: 3,
        spaceBetween: 10
      }
    }
    

  };
  public Newscenter_config: SwiperConfigInterface = {
    direction: 'vertical',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',

    speed: 400,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },

    slidesPerView: 'auto',
    pagination:false,
    // pagination: {
    //   el: ".swiper-pagination",
    //   dynamicBullets: true,
    //   clickable: true,
    // },
    breakpoints: {
      320: {
        slidesPerView: 5,
        spaceBetween: 0
      },
      480: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      640: {
        slidesPerView: 5,
        spaceBetween: 0
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 0
      }
    }

  };
  constructor(private newsService: NewsService, private bannerService: BannerService, private router: Router, private activeroute: ActivatedRoute) { }

  ngOnInit(): void {
    this.items=[
      { routerLink:"/", label:"Home" },
      { label:"Blog" }
    ]
    this.id = this.activeroute.snapshot.params.id;
    this.getBanner();
    this.getNewsdetails();
    //this.blogList();
  }

  // blogList() {
  //   let query = "?filterByDisable=false&sortBy=created_at&orderBy=DESC";
  //   this.blogService.getBlogListwithoutAuth(query).subscribe((data) => {
  //     this.blogs = data.data.items;
  //     console.log(this.blogs);
  //   })
  // }

  getNewsdetails() {
    var query = "?filterByDisable=false&sortBy=created_at&orderBy=DESC";
    this.newsService.getNewsDetails(this.id).subscribe(
      data => {   
        this.loading = false;
        this.newsTitle = data['title'];
        this.newsContent = data['description'];
        this.newsImage=data['newsImage'];
        // console.log(data['newsImage']);
      },
      err => {
        this.errorMessage = err.error.message;
      });
      var query = "?filterByDisable=false&filterByStatus=true";
      console.log('News5666',query);
      this.newsService.getNewsDetails(query).subscribe(
        data => {
          console.log('News',data);
          if (data.data.totalCount > 0) {
            this.tplNews = data.data.items;
          }
        },
        err => {
          this.errorMessage = err.error.message;
        });
  }
  getBanner() {
    let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=blog";
    this.bannerService.getbannerList(query).subscribe(
      data => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.totalRecords = data.data.totalCount;
        this.bannerList.forEach(element => {
          this.bannerImageList = element.banner_image;
        });
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  public toggleDisabled(): void {
    this.disabled = !this.disabled;
  }
  public onIndexChange(index: number): void {
  }

  public onSwiperEvent(event: string): void {
  }

  

}
